export const UserAccountVI = {
    "userAccount":{
        "columns":{
            "id":"ID",
            "screenName":"Tên đăng nhập",
            "fullName":"Tên đầy đủ",
            "creatorName":"Người tạo",
            "createDate":"Ngày tạo"
        },
        timekeeping: {
            title : "Bảng chấm công",
            leaveNoReason: "Nghỉ không lý do",
            dayOff: "Nghỉ tuần",
            day: {
                mon: "Thứ hai",
                tue: "Thứ ba",
                wed: "Thứ tư",
                thu: "Thứ năm",
                fri: "Thứ sáu",
                sat: "Thứ bảy",
                sun: "Chủ nhật"
            }
        }
    }
}